module.exports = __webpack_public_path__ + "img/BoatGameThing.06fb8acf.png";